const { Validator } = require( '@leverege/validator' )
// http://www.w3resource.com/javascript/form/email-validation.php#
function email( email, nullValid ) {  
  if ( nullValid === true && ( email == null || email.trim().length == 0 ) ) { 
    return true
  }
  return Validator.isEmail( email )
  // if ( /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test( email ) ) {  
  //   return true  
  // }  
  // return false
}  
// http://stackoverflow.com/questions/4338267/validate-phone-number-with-javascript
function phone( phone, nullValid ) {
  if ( nullValid === true && ( phone == null || phone.trim().length == 0 ) ) { 
    return true
  }

  const r = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
  if ( r.test( phone ) ) {
    return true
  }
  return false
}

function notNullOrEmpty( str ) {
  if ( str == null ) { 
    return false
  }
  return typeof str === 'string' ? str.trim().length > 0 : true

}

module.exports = { 
  phone,
  email,
  notNullOrEmpty

}
